import React from "react"
import { Box, Button, CircularProgress, Modal, Stack, Typography } from "@mui/material"
import { useImageCrop } from "./useImageCrop"
import { ImageCropProps } from "./types"
import * as s from "./style"
import { COLORS } from "../../../styles/variables"

export const ImageCrop: React.FC<ImageCropProps> = (props) => {
  const { imageSrc, onClose, isSaving = false } = props
  const {
    crop,
    imageLoaded,
    dragMode,
    imgRef,
    onImageLoad,
    handlePointerDown,
    handleSave,
  } = useImageCrop(props)

  return (
    <Modal
      open
      onClose={isSaving ? undefined : onClose}
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <Box sx={s.modalPaperStyle}>
        <Typography variant="h3" mb={2} textAlign="center">
          Редактирование фото
        </Typography>

        <Box sx={s.containerStyle}>
          <img
            ref={imgRef}
            src={imageSrc}
            onLoad={onImageLoad}
            style={{
              maxWidth: "100%",
              maxHeight: "65vh",
              display: "block",
            }}
            draggable={false}
            alt=""
          />

          {!imageLoaded && (
            <CircularProgress size={40} sx={{ color: COLORS.CERULEAN }} />
          )}

          {imageLoaded && (
            <Box
              onPointerDown={(e) => handlePointerDown(e, "move")}
              sx={s.cropFrameStyle(crop, dragMode === "move")}
            >
              <Box
                onPointerDown={(e) => handlePointerDown(e, "resize")}
                sx={s.resizeHandleStyle}
              />
            </Box>
          )}
        </Box>

        <Stack direction="row" spacing={2} mt={3} justifyContent="flex-end">
          <Button onClick={onClose} variant="danger" disabled={isSaving}>
            Отмена
          </Button>
          <Button
            onClick={handleSave}
            variant="follow"
            sx={{ px: 4 }}
            disabled={!imageLoaded || isSaving}
          >
            {isSaving ? (
              <Stack direction="row" alignItems="center" spacing={1}>
                <CircularProgress size={16} color="inherit" />
                <span>Сохранение...</span>
              </Stack>
            ) : (
              'Сохранить'
            )}
          </Button>
        </Stack>
      </Box>
    </Modal>
  )
}
